import { all } from 'redux-saga/effects';
import user from './user/sagas';
import vendor from './vendor/sagas';
import marketplace from './marketplace/sagas';
import product from './product/sagas';
import vendorProduct from './vendorproduct/sagas';
import transaction from './transaction/sagas';
import cart from './cart/sagas';
import category from './category/sagas';
import notification from './notification/sagas';

export default function* rootSaga() {
  yield all([
    user(),
    vendor(),
    marketplace(),
    product(),
    vendorProduct(),
    transaction(),
    cart(),
    category(),
    notification()
  ]);
}
